
export default {
  name: "Band",
};
